import React from 'react';

import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  OutlinedInputProps,
  styled,
} from '@mui/material';
import { CloseCircle, SearchNormal } from 'iconsax-reactjs';

const OutlinedInputStyled = styled(OutlinedInput)(({ theme }) => ({
  // width: '80%',
  padding: '8px 12px',
  borderRadius: '8px',
  border: '1px solid #E1E7EF',
  boxShadow: 'none',
  height: '32px',
  fontSize: '0.75rem',
  color: theme.palette.secondary[900],
  '& .MuiInputBase-input': {
    padding: '0',
    height: '16px',
  },
  '& fieldset, &.Mui-focused fieldset, & .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover fieldset, &:hover .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #A9B3FF',
  },
}));

type IProps = Pick<OutlinedInputProps, 'sx' | 'fullWidth' | 'autoFocus' | 'name'> & {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  endAdornment?: React.ReactNode;
};

const SearchField = React.memo(({ value, onChange, onClear, endAdornment, ...props }: IProps) => {
  const handleSearchChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <OutlinedInputStyled
      size="small"
      startAdornment={
        <InputAdornment position="start">
          <SearchNormal size={16} color="#728196" />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          {endAdornment}

          {value?.length > 0 && (
            <IconButton
              onClick={onClear}
              edge="end"
              sx={{
                padding: '0',
                height: '16px',
                marginRight: '0',
                marginLeft: endAdornment ? '5px' : '0',
              }}
            >
              <CloseCircle size={16} color="#E1E7EF" />
            </IconButton>
          )}
        </InputAdornment>
      }
      value={value}
      onChange={handleSearchChange}
      inputProps={{
        'data-testid': 'search-field',
      }}
      {...props}
    />
  );
});

export default SearchField;
